// extracted by extract-css-chunks-webpack-plugin
module.exports = {"signup-form":"signup-form_zoltb"};